<template>
  <el-select
    v-model="selectedValue"
    placeholder="请选择"
    @change="handleChange"
    :loading="loading"
    clearable
    :disabled="disabled"
    filterable
    style="width: 100%"
  >
    <el-option
      v-for="item in options"
      :key="item.Value"
      :label="item.Name"
      :value="item.Value"
    />
  </el-select>
</template>

<script>
export default {
  name: 'SelectDicValue',
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    code: { type: String, required: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      selectedValue: this.value,
      options: [],
      loading: false,
    }
  },
  watch: {
    value(newValue) {
      this.selectedValue = newValue
    },
    selectedValue(newValue) {
      this.$emit('input', newValue)
    },
  },
  methods: {
    async fetchOptions() {
      this.loading = true
      try {
        await this.$http
          .get('/Base/Base_Enum/GetByCode?code=' + this.code)
          .then((res) => {
            if (res.Success) {
              let resData = res.Data
              this.options = resData.EnumItems
            }
          })
      } catch (error) {
        console.error('Failed to fetch options:', error)
      } finally {
        this.loading = false
      }
    },
    handleChange(value) {
      this.$emit('change', value)
    },
  },
  mounted() {
    this.fetchOptions()
  },
}
</script>

<style scoped></style>
